import { format } from "date-fns";
import React, { useRef } from "react";
import "./../htmlTable.css";
import "./usuarios.css";
import SkeletonTable from "components/proto/components/Skeleton/SkeletonTable";
//import { handleStatus } from "../../helperFunctions/helpers";
import BadgeStatus from "../Asociados/BadgeStatus";

export default function UsuariosTable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <>
      <table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="id"
              style={{ width: "50px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>
            <th
              scope="col"
              data-column="nombre"
              onClick={(event) => handleSort(event)}
            >
              Nombre
            </th>
            <th
              scope="col"
              data-column="FechaNacimiento"
              style={{ width: "150px" }}
              onClick={(event) => handleSort(event)}
            >
              Fecha nacimiento
            </th>
            <th
              scope="col"
              data-column="Correo"
              onClick={(event) => handleSort(event)}
            >
              Email
            </th>
            {/*  <th
              scope="col"
              data-column="CiudadId"
              onClick={(event) => handleSort(event)}
            >
              Ciudad
            </th>*/}
            <th
              scope="col"
              data-column="Departamento"
              style={{ width: "130px" }}
              onClick={(event) => handleSort(event)}
            >
              Departamento
            </th>
            <th
              scope="col"
              data-column="NivelUsuarioId"
              style={{ width: "150px" }}
              onClick={(event) => handleSort(event)}
            >
              Nivel
            </th>
            <th
              scope="col"
              data-column="activo"
              style={{ width: "80px" }}
              onClick={(event) => handleSort(event)}
            >
              Estatus
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={7} rowCount={6} />}

          {!isLoading &&
            items?.length > 0 &&
            items.map((item) => {
              const bDay = format(item.fechaNacimiento, "dd/MM/yy");

              return (
                <tr key={item.id}>
                  <th
                    scope="row"
                    style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.id ? item.id : ""}
                    </a>
                  </th>

                  <td>
                    <a
                      href="#"
                      className="text-primary"
                      onClick={(e) => openItem(item)}
                    >
                      {`${item.nombre ? item.nombre : ""} ${
                        item.apellidoPaterno ? item.apellidoPaterno : ""
                      } ${item.apellidoMaterno ? item.apellidoMaterno : ""}`}
                    </a>
                  </td>
                  <td>{bDay}</td>
                  <td>{item.correo}</td>
                  {/*<td>{item.ciudad?.nombre}</td>*/}
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {item.departamento?.nombre}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {item.nivelUsuario?.nombre}
                  </td>
                  <BadgeStatus item={item} />
                </tr>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
